// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"56da5d08","732":"1b07a7b8"}[chunkId] + ".chunk.js";
};